import { useNavigate } from 'react-router-dom';

const RedirectExample = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        console.log("Clicked");
        navigate("/")      
    };

    return(
        <>
        <h1>Hello from RedirectExample</h1>
        <button onClick={handleClick}>Click to redirect</button>
        </>
    );
};

export default RedirectExample;